import { TreeNode } from "@/types/tree";
import * as t from "io-ts";
import { UnsplashImage } from "../api/unsplash";

export type ImageControlInfo = {
  nodeId: TreeNode['id'];
  controlPath: string;
};

export type SimplifiedTreeNodeForLLM = {
  nodeType: string;
  nodeId: string;
  content?: any;
  children?: SimplifiedTreeNodeForLLM[];
}

export const KeywordsForImageInNodeV = t.type({
  nodeId: t.number,
  controlPath: t.string,
  keywords: t.array(t.string)
});

export type KeywordsForImageInNode = t.TypeOf<typeof KeywordsForImageInNodeV>;

export const KeywordsForImageInNodeResponseV = t.type({
  response: t.array(KeywordsForImageInNodeV)
});

export type KeywordsForImageInNodeResponse = t.TypeOf<typeof KeywordsForImageInNodeResponseV>;

export type FutureLayerImageMeta = ImageControlAndInfo[];

export type ImageControlAndInfo = {
  controlPath: string;
  keywords: string[];
  searchResults: UnsplashImage[];
  width?: number;
};

export type ImageControlsAndInfoGroupedByNodeId = {
  nodeId: TreeNode['id'];
  data: ImageControlAndInfo[];
}[];

export type UpdateMode = 'store' | 'mutate';
